import {useEffect, useRef, forwardRef} from 'react';
import { Link } from 'react-router-dom';

const Express = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`).scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 50)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+200;

        (top > header_height && window_width > 1024) ? document.querySelector("header").classList.add('fixed-header-desktop') : document.querySelector("header").classList.remove('fixed-header-desktop')
    }, false);
    return(
         <div>
            {/* <div className="express"> 
              
            
            </div> 
             */}
            <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto  p-[3rem]">
                <p>
                    In 1983, with twelve Express Centres and twenty-five shipments is where it started for TCS. 
                    Now with a network of more than 1,000 retail centres in the country, backed by a fleet of 
                    thousands of delivery conveyances and an aviation division, TCS Express is the largest courier 
                    and logistics network in Pakistan.
                </p>
                <p>
                    Busy serving customers 24 hours a day, the Express operation is the bedrock of TCS products 
                    and services. Five different classes of TCS Express Centres, which include COCO, Franchised, 
                    Shop-in-Shop, Agents and IBRS, serve as a one-stop-shop for our customers.
                </p>

                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="flex">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/express/domesticexpress" className="font-bold">Domestic Express</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/express/internationalexpress" className="font-bold">International Express</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/express/ecom-solutions" className="font-bold">E-com Solutions</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/express/travel-and-tour" className="font-bold">Travel & Tours</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/express/visatronix" className="font-bold">Visatronix</Link></li>
                            </div>

                            <div className="flex items-center ">
                                <li><Link to="/express/financial-services" className="font-bold">Financial Services</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/express/mms" className="font-bold">MMS</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/express/aviation" className="font-bold">Aviation</Link></li>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    );
};
export default Express;